// Module
var code = "<div class=\"implioicons-copy-large eva-copy-icon eva-tooltip-container--center\" data-ng-click=\"vm.clicked()\"> <span class=\"eva-tooltip\">{{'ITEM.COPY_TOOLTIP' |t}}</span> </div> ";
// Exports
module.exports = code;